export default __webpack_public_path__ + "static/media/9_16-story-ad-web.528e2db4.png";